<template>
  <div class="about-container">
    <!-- 品牌介绍页面头部 -->
    <div class="page-header">
      <h1 class="page-title">{{$t('about.pageTitle')}}</h1>
    </div>

    <!-- 品牌介绍部分 -->
    <section class="company-section">
      <div class="intro-container">
        <div class="intro-image">
          <img src="@/assets/images/n1.jpg" alt="中策橡胶集团总部" class="intro-img">
        </div>
        <div class="intro-content">
          <h2 class="intro-title">{{$t('about.brandIntroTitle')}}</h2>
          <p class="intro-text">{{$t('about.brandIntroText')}}</p>

          <h2 class="intro-title mt-40">{{$t('about.groupIntroTitle')}}</h2>
          <p class="intro-text">{{$t('about.groupIntroText1')}}</p>
          <p class="intro-text">{{$t('about.groupIntroText2')}}</p>

        </div>
      </div>
    </section>

    <!-- 品牌大事记部分 -->
<!--    <section class="milestones-section">-->
<!--      <h2 class="main-section-title">品牌大事记</h2>-->
<!--      <div class="milestone-image">-->
<!--        <img src="@/assets/images/milestone.png" alt="品牌大事记" class="full-width-img">-->
<!--      </div>-->
<!--    </section>-->

    <!-- 合作伙伴部分 -->
    <section class="partners-section">
      <h2 class="main-section-title">{{$t('about.partnersTitle')}}</h2>
      <div class="partners-image">
        <img src="@/assets/images/company.png" alt="合作伙伴" class="full-width-img">
      </div>
    </section>

    <!-- 品牌成就部分 -->
    <section class="achievements-section">
      <h2 class="main-section-title">{{$t('about.achievementsTitle')}}</h2>

      <div class="achievements-category">
        <h3 class="category-title">{{$t('about.governmentAwardsTitle')}}</h3>
        <div class="achievement-grid">
          <div class="achievement-item" v-for="(award, index) in governmentAwards" :key="`gov-award-${index}`">
            <div class="achievement-image">
              <img :src="require(`@/assets/images/aw${index+1}.jpg`)" :alt="award.title" class="award-img">
            </div>
            <div class="achievement-caption">{{$t('about.governmentAwards.' + index)}}</div>
          </div>
        </div>
      </div>

      <div class="achievements-category">
        <h3 class="category-title">{{$t('about.manufacturerAwardsTitle')}}</h3>
        <div class="achievement-grid">
          <div class="achievement-item" v-for="(award, index) in manufacturerAwards" :key="`industry-award-${index}`">
            <div class="achievement-image">
              <img :src="require(`@/assets/images/awq${index+1}.jpg`)" :alt="award.title" class="award-img">
            </div>
            <div class="achievement-caption">{{$t('about.manufacturerAwards.' + index)}}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from '@/components/SiteFooter.vue';
import { getBrandInfo } from '@/api/brand';

export default {
  name: 'AboutPage',
  components: {
    SiteFooter
  },
  data() {
    return {
      brandData: null,
      governmentAwards: [
        { title: '2016年第二届浙江省工业大奖金奖' },
        { title: '2016年杭州十二五纳税百强企业' },
        { title: '2016年中国标准创新贡献奖' },
        { title: '2016年中国对外贸易500强企业' },
        { title: '2017年中国轮胎企业排行榜第一名' },
        { title: '2020年杭州市首批鲲鹏企业' }
      ],
      manufacturerAwards: [
        { title: '2014年长安汽车优秀供应商奖' },
        { title: '2015年北汽福田优秀供应商奖' },
        { title: '2015年广西柳工优秀供应商奖' },
        { title: '2015年江淮汽车优秀供应商奖' },
        { title: '2015年上汽通用优秀绿色供应商奖' },
        { title: '2016年奇瑞捷豹路虎X260L最佳投产奖' },
        { title: '2017年江淮汽车优秀供应商奖' },
        { title: '2017年陕汽重卡优秀供应商奖' },
        { title: '2017年一汽解放优秀供应商奖' }
      ]
    };
  },
  created() {
    this.fetchBrandInfo();
  },
  methods: {
    async fetchBrandInfo() {
      try {
        const response = await getBrandInfo();
        console.log('Brand API Response:', response);
        this.brandData = response;

        // 分析返回数据结构
        if (response && response.rows) {
          console.log('Total items:', response.rows.length);

          // 分析数据类型
          const types = {};
          response.rows.forEach(item => {
            if (!types[item.type]) {
              types[item.type] = 1;
            } else {
              types[item.type]++;
            }
          });
          console.log('Item types distribution:', types);

          // 打印第一条记录的所有字段
          if (response.rows.length > 0) {
            console.log('First item fields:', Object.keys(response.rows[0]));
            console.log('Sample item:', response.rows[0]);
          }
        }
      } catch (error) {
        console.error('Error fetching brand info:', error);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Variables
$primary-color: #ed1c24; // BullTire Red
$secondary-color: #222; // Dark Grey/Black
$light-color: #fff;
$gray-color: #f5f5f5;
$dark-text: #212529;
$light-text: #fff;
$border-radius: 4px;

// Breakpoints
$mobile: 767px;
$tablet: 1024px;

// Section padding
$section-padding: 80px 0;

.about-container {
  padding-top: 70px; /* 为固定的header留出空间 */
  background-color: #f9f9f9;
}

/* 页面头部样式 */
.page-header {
  background-color: #f1f1f1;
  background-image: url('@/assets/images/about-header.png');
  background-size: cover;
  background-position: center;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 10%;
  position: relative;
  margin-bottom: 40px;
}

.page-title {
  font-size: 40px;
  font-weight: bold;
  color: white;
  position: relative;
  z-index: 2;
}

/* 介绍部分样式 - 与Home.vue保持一致 */
.company-section {
  padding: 0;
  background-color: #f9f9f9;

  @media (max-width: $mobile) {
    padding: 0 20px;
  }
}

.intro-container {
  display: flex;
  max-width: 100%;
  margin: 0;
  gap: 0;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);

  @media (max-width: $tablet) {
    flex-direction: column;
  }
}

.intro-image {
  flex: 0 0 45%;
  height: auto;
  min-height: auto;
  background-color: #f5f5f5;
  position: relative;
  overflow: hidden;

  .intro-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0;
    box-shadow: none;

    @media (max-width: $mobile) {
      width: 100%;
      height: auto;
      position: static;
      object-fit: contain;
    }
  }

  @media (max-width: $tablet) {
    height: auto;
    flex: 0 0 auto;
  }

  @media (max-width: $mobile) {
    min-height: auto;
    height: auto;
  }
}

.intro-content {
  flex: 1;
  padding: 60px;
  background-color: #fff;
  min-width: auto;

  @media (max-width: $mobile) {
    padding: 40px 20px;
  }
}

.intro-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  color: $dark-text;
  position: relative;
}

.intro-title::after {
  display: none; /* 移除下划线 */
}

.intro-text {
  margin-bottom: 20px;
  line-height: 1.8;
  color: #666;
  font-size: 16px;
}

.mt-40 {
  margin-top: 40px;
}

/* 大事记部分样式 */
.milestones-section {
  padding: 0;
  width: 100%;
  background-color: #f9f9f9;
  overflow: hidden;
}

.main-section-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 40px;
  text-align: center;
  position: relative;
  padding-top: 60px;
  width: 100%;
}

.main-section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #e60012;
}

.milestone-image {
  width: 100%;
  margin: 0;
  padding: 0;
}

.full-width-img {
  width: 100%;
  display: block;
  border-radius: 0;
  box-shadow: none;
  max-width: 100%;
}

/* 合作伙伴部分样式 */
.partners-section {
  padding: 0;
  width: 100%;
  background-color: white;
  overflow: hidden;
}

.partners-image {
  width: 100%;
  margin: 0;
  padding: 0;
}

/* 品牌成就部分样式 */
.achievements-section {
  padding: 60px 10%;
  background-color: #f9f9f9;
}

.achievements-category {
  margin-bottom: 50px;
}

.category-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  position: relative;
  padding-left: 15px;
}

.category-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 5px;
  height: 20px;
  background-color: #e60012;
}

.achievement-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 25px;
}

.achievement-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.achievement-image {
  width: 100%;
  height: 150px;
  overflow: hidden;
  border-radius: 5px;
  margin-bottom: 10px;
}

.award-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.achievement-caption {
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .intro-container {
    flex-direction: column;
  }

  .achievement-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  .page-header {
    height: 125px;
    min-height: 125px;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .page-title {
    font-size: 32px;
  }

  .center-highlight {
    width: 120px;
    height: 120px;
  }
}
</style>
